import { SolutionCatalogType } from '@sharefile/packaging-types';
import { CollectionViewMode } from '@sharefiledev/rubicon-pilet-sdk';
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';
import { SolutionDetailsViewMode } from './enums';

export interface ShellProps {
	piletApi: PiletApi;
}

export interface TemplateDrawerConfig {
	title: string;
	footer: {
		createButton: string;
		cancelButton: string;
	};
}

/** Block parameters for urn:block:rubicon-pilet:solution-list */

export interface SolutionListBlockParams {
	/**
	 * Container RID to filter solutions by
	 */
	containerRID?: string;
	/**
	 * Namespace to filter solutions by
	 */
	namespace?: string;
	/**
	 * Catalog type to filter solutions by
	 */
	catalogType?: SolutionCatalogType;
	/**
	 * Collection view mode
	 */
	collectionViewMode?: CollectionViewMode;
	/**
	 * Array of solution names to filter by
	 */
	solutionNames?: string[];
	/**
	 * Hide the default header completely
	 */
	hideHeader?: boolean;
	/**
	 * Sleek subtitle configuration
	 */
	subtitle?: {
		/**
		 * Subtitle text to display
		 */
		label?: string;
		/**
		 * Subtitle alignment
		 */
		align?: 'left' | 'center' | 'right';
	};
	/**
	 * Details view mode
	 */
	detailsViewMode?: SolutionDetailsViewMode;
	/**
	 * Resource type for template operations
	 */
	resourceType?: string;
	/**
	 * Template drawer configuration
	 */
	templateDrawerConfig?: TemplateDrawerConfig;
	/**
	 * Template drawer event URN for opening the template drawer
	 */
	templateDrawerEventUrn?: string;
	/**
	 * Custom metadata to include in Pendo tracking events
	 */
	pendoCustomMetadata?: {
		[k: string]: string;
	};
}

export namespace BlockNames {
	export const SolutionList = 'urn:block:rubicon-pilet:solution-list' as const;
	export type SolutionList = 'urn:block:rubicon-pilet:solution-list';
}

export namespace ZoneTypes {}

export type SolutionListProps = ShellProps & BlockParams & SolutionListBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:rubicon-pilet:solution-list']: BlockParams & SolutionListBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {}

	interface ViewEngineCustomZoneContractDataMap {}
}
